import { useEffect, useState } from "react";

const GlobalLoader = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  return isLoading ? (
    <div className="fixed inset-0 flex items-center justify-center bg-background text-foreground">
      <span className="text-xl animate-pulse">Loading...</span>
    </div>
  ) : (
    children
  );
};

export default GlobalLoader;
